import styled, { css } from 'styled-components';
import { TokenSet } from '../../styles/tokens';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
type Size = 'sm' | 'md' | 'lg';

interface Props {
  tokens: TokenSet;
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const Button = styled.button<Props>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s ease;
  white-space: nowrap;

  ${p => p.size === 'sm' && css`padding: 6px 12px; font-size: 13px;`}
  ${p => (!p.size || p.size === 'md') && css`padding: 10px 20px; font-size: 14px;`}
  ${p => p.size === 'lg' && css`padding: 14px 28px; font-size: 16px;`}

  ${p => p.fullWidth && css`width: 100%;`}

  ${p => (!p.variant || p.variant === 'primary') && css`
    background: ${p.tokens.primary};
    color: #fff;
    &:hover:not(:disabled) { background: ${p.tokens.primaryLight}; transform: translateY(-1px); }
    &:active:not(:disabled) { transform: translateY(0); }
  `}

  ${p => p.variant === 'secondary' && css`
    background: ${p.tokens.bgElevated};
    color: ${p.tokens.text};
    border: 1px solid ${p.tokens.border};
    &:hover:not(:disabled) { border-color: ${p.tokens.primary}; color: ${p.tokens.primary}; }
  `}

  ${p => p.variant === 'danger' && css`
    background: ${p.tokens.danger};
    color: #fff;
    &:hover:not(:disabled) { opacity: 0.85; }
  `}

  ${p => p.variant === 'ghost' && css`
    background: transparent;
    color: ${p.tokens.textMuted};
    &:hover:not(:disabled) { color: ${p.tokens.text}; background: ${p.tokens.bgElevated}; }
  `}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
